import Api from '../../library/api';
import { showError } from '../snackbars/snackbars-actions';

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const REMEMBER_ME = 'REMEMBER_ME';
export const FORGET_ME = 'FORGET_ME';

export function login(email, password, rememberMe) {
  return dispatch => {

    if (rememberMe === true) dispatch({type: REMEMBER_ME, payload: {email: email}});
    if (rememberMe === false) dispatch({type: FORGET_ME});

    dispatch({type: REQUEST_LOGIN});

    Api.post('p/login', {email: email, password: password})
      .then(resp => {

        if (resp.err) {
          dispatch({type: LOGIN_FAILED});
          dispatch(showError(resp.err));
          return
        }

        // "admin": false,
        // "role": "Owner",
        // "business": true,
        // "business_name": "Enjoy Space"

        resp.permissions = {
          admin: resp.admin
        };

        dispatch({
          type: LOGIN_SUCCESS,
          payload: resp
        })

      });

  }
}



// WEBPACK FOOTER //
// ./src/components/login/login-actions.js